import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@eventbrite/eds-modal';
import { gettext } from '@eventbrite/i18n';
import { isAnEmail } from '@eventbrite/validators';
import isEmpty from 'lodash/isEmpty';

import { DATA_HEAP_ID_SEND_A_LOGIN_LINK_BUTTON } from '../../constants/analytics';
import { PASSWORDLESS_EMAIL_STATUSES } from '../../constants/status';

import { Button } from '@eventbrite/eds-button';

import PasswordlessEmailStatus from '../../components/PasswordlessEmailStatus';
import PasswordlessLimitReached from '../../components/PasswordlessLimitReached';
import PasswordlessForm from '../../components/newForms/PasswordlessForm';

import './PasswordlessModal.scss';

const PassdwordlessSection = ({
    handleSendPasswordlessLink,
    setPasswordlessEmailStatus,
    trackOpenPasswordlessModal,
    trackClosePasswordlessModal,
    dataTestId = 'passwordless-link',
    passwordlessEmailStatus,
    previousFormEmail,
    clearAuthNotification,
    setShowPasswordlessModal,
    showPasswordlessModal,
    passwordlessEnterValidEmail,
    signUpSecondStep,
}) => {
    const [passwordlessEmail, setPasswordlessEmail] = useState('');

    const _handleOpenModal = () => {
        clearAuthNotification();
        //If user has completed email in Login form, then send email
        if (!isEmpty(previousFormEmail)) {
            if (isAnEmail(previousFormEmail)) {
                setShowPasswordlessModal(true);
                trackOpenPasswordlessModal();
                _handlePasswordlessEmail({
                    email: previousFormEmail,
                    isDirect: true,
                });
                setPasswordlessEmailStatus(PASSWORDLESS_EMAIL_STATUSES.ongoing);
            } else {
                passwordlessEnterValidEmail();
            }
        } else {
            setShowPasswordlessModal(true);
            trackOpenPasswordlessModal();
            setPasswordlessEmailStatus('');
        }
    };

    const _handlePasswordlessEmail = ({ email, isDirect = false }) => {
        setPasswordlessEmail(email);
        handleSendPasswordlessLink?.({ email, isDirect });
    };

    const _handleCloseModal = () => {
        clearAuthNotification();
        setShowPasswordlessModal(false);
        trackClosePasswordlessModal();
        setPasswordlessEmailStatus('');
    };

    let body = (
        <PasswordlessForm
            onSubmit={_handlePasswordlessEmail}
            autoFocus={showPasswordlessModal}
            dataTestId={`${dataTestId}-form`}
            isSubmitOngoing={
                passwordlessEmailStatus === PASSWORDLESS_EMAIL_STATUSES.ongoing
            }
            signUpSecondStep={signUpSecondStep}
            onClickBackToLogin={_handleCloseModal}
            initialValues={{ email: previousFormEmail }}
        />
    );

    if (passwordlessEmailStatus === PASSWORDLESS_EMAIL_STATUSES.delivered) {
        body = (
            <PasswordlessEmailStatus
                email={passwordlessEmail}
                onClick={_handleCloseModal}
            />
        );
    }

    if (passwordlessEmailStatus === PASSWORDLESS_EMAIL_STATUSES.limitReached) {
        body = (
            <PasswordlessLimitReached
                email={passwordlessEmail || previousFormEmail}
                onClick={_handleCloseModal}
            />
        );
    }

    return (
        <div className="forgot-password-modal" data-testid={dataTestId}>
            <div className="eds-text-bm eds-text-weight--heavy">
                <Button
                    type="button"
                    size="block"
                    onClick={_handleOpenModal}
                    disabled={false}
                    data-testid={`${dataTestId}-button`}
                    data-heap-id={DATA_HEAP_ID_SEND_A_LOGIN_LINK_BUTTON}
                >
                    {gettext('Email me a login link')}
                </Button>
            </div>

            <Modal
                noMinHeight={true}
                isShown={showPasswordlessModal}
                onClose={_handleCloseModal}
            >
                <div className="eds-l-pad-all-8 eds-align--center">{body}</div>
            </Modal>
        </div>
    );
};

PassdwordlessSection.propTypes = {
    handleSendPasswordlessLink: PropTypes.func.isRequired,
    setPasswordlessEmailStatus: PropTypes.func.isRequired,
    trackOpenPasswordlessModal: PropTypes.func.isRequired,
    setShowPasswordlessModal: PropTypes.func.isRequired,
    passwordlessEnterValidEmail: PropTypes.func.isRequired,
    passwordlessEmailStatus: PropTypes.string,
    showPasswordlessModal: PropTypes.bool,
    dataTestId: PropTypes.string,
    // We use the email from the previous form to have it pre-populated
    previousFormEmail: PropTypes.string,
};

export default PassdwordlessSection;
